import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/ubuntu/400.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';
import App from './App';

const container = document.getElementById('root');

if (!container) {
	throw new Error('Root element #root was not found.');
}

const root = createRoot(container);
root.render(
	<StrictMode>
		<App />
	</StrictMode>
);
